@if (params()?.value?.length) {
  <span class="count-cell-value">{{ $safeNavigationMigration(params()?.value.length) | numberFormat }}</span>
} @else {
  <span class="count-cell-value">-</span>
}
